import { parseAsDate } from "@/shared/utils/date";
import { OperatorEnum } from "@spz/shared-domain";

export function formatAsLocalISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export type ShortDateValueItem = string | number | undefined;

export const getShortDateFilterValue = ({
  column,
  min,
  max,
}: { column: string; min: ShortDateValueItem; max: ShortDateValueItem }) => {
  const from = min ? parseAsDate(Number(min)) : undefined;
  const to = max ? parseAsDate(Number(max)) : undefined;
  if (from && to)
    return {
      column,
      operator: OperatorEnum.BETWEEN,
      value: [formatAsLocalISO(from), formatAsLocalISO(to)],
    };
  if (from)
    return {
      column,
      operator: OperatorEnum.GTE,
      value: formatAsLocalISO(from),
    };
  if (to)
    return {
      column,
      operator: OperatorEnum.LTE,
      value: formatAsLocalISO(to),
    };
  return null;
};
